<div class="forgot-layout">
  <div class="brand-column">
    <mat-card class="forgot-card">
      @if (loading()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      <img class="forgot-logo" src="/assets/p4c-logo-black.png" alt="Privacy4Cars"/>
      <mat-card-header>
        <mat-card-title style="color: #000;">Reporting Portal</mat-card-title>
        <mat-card-subtitle>
          Business Intelligence and Usage Reporting
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        @if(step() === 'forgot') {
        <form [formGroup]="forgotPasswordForm" class="forgot-form">
         <mat-form-field appearance="outline">
           <mat-label>Email ID</mat-label>
           <input matInput type="emailId" formControlName="emailId" placeholder="Enter Email ID to get the OTP"/>
           <mat-icon matSuffix>mail</mat-icon>
           @if (forgotPasswordForm.controls['emailId'].touched && forgotPasswordForm.controls['emailId'].invalid) {
        <mat-error>Enter a valid email address.</mat-error>
        }
        </mat-form-field>
      </form>
        }
        @else {
        <form [formGroup]="resetPasswordForm" class="forgot-form">
          <mat-form-field appearance="outline">
            <mat-label>OTP</mat-label>
            <input matInput type="text" placeholder="OTP" name="otp" placeholder="Enter the OTP"
                   formControlName="otp">
            <mat-icon [color]="(resetPasswordForm.controls['otp'].invalid && resetPasswordForm.controls['otp'].touched) ? 'warn':'primary'" matSuffix>dialpad</mat-icon>
            @if (resetPasswordForm.controls['otp'].invalid && resetPasswordForm.controls['otp'].touched) {
        <mat-error>OTP is required</mat-error>
        }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>New Passphrase</mat-label>
          <input matInput type="password" formControlName="newPassword" autocomplete="newPassword" placeholder="Enter New Passphrase"/>
          <mat-icon matSuffix>lock</mat-icon>
          @if (resetPasswordForm.controls['newPassword'].touched && resetPasswordForm.controls['newPassword'].invalid) {
        <mat-error>Passphrase is required.</mat-error>
        }
        </mat-form-field>
      </form>
        }
      </mat-card-content>
      <mat-card-actions class="forgot-actions">
        @if(step() === 'forgot') {
        <button mat-button (click)="backToLogin()">
          Back to login
        </button>
        <button mat-flat-button color="primary" (click)="submitEmail(forgotPasswordForm)" [disabled]="forgotPasswordForm.invalid">
          Generate OTP
        </button>
        } @else {
        <button mat-button (click)="backToLogin()">
         Cancel
       </button>
       <button mat-flat-button color="primary" (click)="resetPassword(resetPasswordForm)" [disabled]="resetPasswordForm.invalid">
        Submit
       </button>
        }
      </mat-card-actions>
    </mat-card>
  </div>
</div>
